import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import styled from "styled-components";

import EntityComponent from "../../common/entity-component";
import Snackbar from "../../common/Snackbar";

import config from "./config";
import QuoteForm from "./form";
import Store from "../../../types/Store";

import getAllQuotes from "../../../database/quotes/getAllQuotes";
import ImportQuotes from "./components/ImportQuotes";
import { Quote } from "../../../types/Quote";
import useQuotes from "../../../database/quotes/useQuotes";
import StoreUser from "../../../types/StoreUser";

import { DesignSystemSurface, PageHeader } from "../../../design-system";

const Page = styled.div`
  min-height: calc(100vh - 104px);
  padding: var(--space-6) var(--space-6) var(--space-16);
`;

const PageInner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

type Props = {
  store: Store;
  user: StoreUser;
};

const QuoteScreen = ({ user }: Props) => {
  let _passwordEdited = "";
  const [isSnackbarOpen, setIsSnackbarOpen] = useState(false);

  const { createQuote, updateQuote, deleteQuote } = useQuotes({
    communityId: user.communityId,
  });
  const authorResponse = getAllQuotes({ communityId: user?.communityId });

  useEffect(() => {
    // intentionally empty — snackbar wiring deferred
  }, [authorResponse]);

  const onCreateQuote = async (quote: Quote) => {
    createQuote(quote);
  };

  const onRemoveQuote = (QuoteRemovedId) => {
    deleteQuote(QuoteRemovedId.id);
  };

  const onEditQuote = (quoteEdited: Quote): void => {
    updateQuote(quoteEdited.id || quoteEdited.stepID, quoteEdited);
  };

  const onEditPassword = (newPassword: string): void => {
    _passwordEdited = newPassword;
  };

  const renderSnackbar = (response: any): React.ReactNode => {
    const { message, error } = response;
    return (
      <Snackbar
        onCloseSnackbar={() => setIsSnackbarOpen(false)}
        isOpen={isSnackbarOpen}
        message={message}
        error={error}
      />
    );
  };

  const Quotenames = authorResponse.map((Quote) => Quote.fullName);

  return (
    <DesignSystemSurface>
      <Page>
        <PageInner>
          <PageHeader
            title="Quotes"
            subtitle="Short lines surfaced in your community content."
            actions={<ImportQuotes communityId={user?.communityId} />}
          />
          <Fragment>
            <EntityComponent
              onRemoveItem={onRemoveQuote}
              onCreateItem={onCreateQuote}
              onEditItem={onEditQuote}
              singularEntityName="Quote"
              pluralEntityName="Quotes"
              filterConfig={config.filterConfig}
              tabConfig={config.tabConfig}
              dataset={authorResponse}
              canBeRemoved
              canBeCreated
              canBeEdited
              Form={(props) => (
                <QuoteForm
                  onEditPassword={onEditPassword}
                  Quotenames={Quotenames}
                  {...props}
                />
              )}
            />
            {renderSnackbar(authorResponse)}
          </Fragment>
        </PageInner>
      </Page>
    </DesignSystemSurface>
  );
};

const mapStateToProps = (state) => ({
  store: state.store,
  user: state.storeUser,
});

export default connect(mapStateToProps, null)(QuoteScreen);
